import React from 'react';
import { IPluginWrapperProps } from './pluginWrapper.types';

class PluginWrapper extends React.Component<IPluginWrapperProps> {
    constructor(props: IPluginWrapperProps | Readonly<IPluginWrapperProps>) {
        super(props);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render(): JSX.Element {
        return <>{this.props.children}</>;
    }
}

export default PluginWrapper;
